module.exports = __webpack_public_path__ + "static/graphic-org-d177b4fdbb34191669351d2bdc02654b.svg";